import { msgConstants } from "../constants";

export const msgActions = {
  success,
  error,
  clear
};

function success(header, message) {
  return { type: msgConstants.SUCCESS, header, message };
}

function error(header, message, errorCb, unknown) {
  return { type: msgConstants.ERROR, header, message, errorCb, unknown };
}

function clear() {
  return { type: msgConstants.CLEAR };
}
